"use client";

import S from "./index.module.scss";
import CustomIcon from "@/components/ui/custom-icon";
import Link from "next/link";
import { Container } from "@/components/ui/container";
import Navigation from "@/components/entities/footer/navigation";
import { usePathname } from "next/navigation";
import { scrollToTop } from "@/utils/helpers";
import Picture from "@/components/ui/picture";

const Footer = () => {
  const pathname = usePathname();

  return (
    <>
      {pathname !== "/configurator" && (
        <Picture
          className={S.image}
          alt="Мастер за работой"
          image={{
            desktop: {
              jpg_default: "/images/footer.jpg",
              webp_default: "/images/footer.jpg",
              jpg_double: "/images/footer.jpg",
              webp_double: "/images/footer.jpg",
            },
            tablet: {
              jpg_default: "/images/footer.jpg",
              webp_default: "/images/footer.jpg",
              jpg_double: "/images/footer.jpg",
              webp_double: "/images/footer.jpg",
            },
            mobile: {
              jpg_default: "/images/footer-mobile.jpg",
              webp_default: "/images/footer-mobile.jpg",
              jpg_double: "/images/footer-mobile.jpg",
              webp_double: "/images/footer-mobile.jpg",
            },
          }}
        />
      )}
      <footer className={S.footer}>
        <Container className={S.container}>
          <div className={S.content}>
            <div className={S.brand}>
              <CustomIcon fileName="icon-logo" className={S.logo} />
              <p className={S.description}>
                Шедевры часового искусства, созданные в традициях северной архитектуры и утончённости ар-деко.
              </p>
            </div>
            <div className={S.control}>
              <Navigation />
              <button type="button" className={S.buttonToTop} onClick={scrollToTop}>
                <CustomIcon fileName="icon-arrow" className={S.iconToTop} />
              </button>
            </div>
          </div>
        </Container>
        <div className={S.borderWrapper}>
          <Container className={S.containerWithBorder}>
            <div className={S.policyWrapper}>
              <span className={S.rights}>© 2026 ALEKSANDR NESTERENKO. Все права защищены.</span>
              <Link href="/policy" className={S.policyLink}>
                Политика конфиденциальности
              </Link>
            </div>
          </Container>
        </div>
      </footer>
    </>
  );
};

export default Footer;
